import axios, { AxiosRequestConfig } from 'axios';

const client = axios.create({
  timeout: 30000,
});

export const request = Object.assign(requestImpl, {
  post: axios.post,
  get: axios.get,
});

function requestImpl(config: AxiosRequestConfig) {
  return client(config).catch((err) => {
    if (axios.isAxiosError(err)) {
      if (err.response) {
        if (err.response.status === 401) {
        }
      }
    }
    throw err;
  });
}
